import { NewPageFeedCommentResponse, PageFeedComment } from 'model/indexTS';

export const getPageFeedCommentFromResponse = (pageFeedFromResponse: NewPageFeedCommentResponse): PageFeedComment => {
  return {
    ...pageFeedFromResponse,
    createdAt: new Date(pageFeedFromResponse.createdAt),
    updatedAt: new Date(pageFeedFromResponse.updatedAt),
    deleted: pageFeedFromResponse.deleted ?? false,
    tippedAmount: pageFeedFromResponse.tippedAmount ?? 0,
  };
};

export const getNormalizedPageFeedCommentFromResponse = (
  pageFeedCommentFromResponse: NewPageFeedCommentResponse[],
): PageFeedComment[] => pageFeedCommentFromResponse.map(getPageFeedCommentFromResponse);
